// A trial open on the company's loaded data (modules' migration/trial.ts): everything the office changes
// is thrown away when it ends, and nothing goes to customers or suppliers meanwhile. The office's one
// read of it, set from /auth/session as the mode is (App.tsx), and by the migration place as it starts
// or ends one.
import { useSyncExternalStore } from 'react';

export type OpenTrial = { state: 'starting' | 'on' | 'ending'; since: string | null } | null;

/** What the notice says (the server's TRIAL_NOTICE, shortened for one line). */
export const TRIAL_LINE = 'Trial: everything you change here is thrown away when the import resumes.';

let trial: OpenTrial = null;
const listeners = new Set<() => void>();

export function setTrial(next: OpenTrial | undefined): void {
  const t = next ?? null;
  if (t?.state === trial?.state && t?.since === trial?.since) return;
  trial = t;
  for (const l of listeners) l();
}

const read = (): OpenTrial => trial;

export function useTrial(): OpenTrial {
  // the same read on the server: a page drawn by renderToString (the a11y tests) needs one
  return useSyncExternalStore(
    (l) => {
      listeners.add(l);
      return () => listeners.delete(l);
    },
    read,
    read,
  );
}
